import { jsxs as f, jsx as i } from "react/jsx-runtime";
import { c as r } from "./clsx-OuTLNxxd.js";
import { V as v } from "./main-GrzMmsgg.js";
const x = "_section_g0e0c_29", N = "_content_g0e0c_32", e = {
  section: x,
  content: N,
  "is-top-bottom-padding": "_is-top-bottom-padding_g0e0c_35",
  "has-small-padding": "_has-small-padding_g0e0c_38",
  "has-medium-padding": "_has-medium-padding_g0e0c_41",
  "has-large-padding": "_has-large-padding_g0e0c_44",
  "bg-image": "_bg-image_g0e0c_48",
  "image-flex": "_image-flex_g0e0c_53",
  "image-container": "_image-container_g0e0c_63",
  "reverse-bg-color": "_reverse-bg-color_g0e0c_82",
  "image-reverse": "_image-reverse_g0e0c_88",
  "is-full-height": "_is-full-height_g0e0c_94",
  "center-content": "_center-content_g0e0c_97",
  "border-top": "_border-top_g0e0c_101",
  "border-bottom": "_border-bottom_g0e0c_104",
  "border-top-and-bottom": "_border-top-and-bottom_g0e0c_107",
  "is-primary": "_is-primary_g0e0c_111",
  "is-secondary": "_is-secondary_g0e0c_114",
  "is-tertiary": "_is-tertiary_g0e0c_117",
  "dialog-overlay-show": "_dialog-overlay-show_g0e0c_1",
  "dialog-content-show": "_dialog-content-show_g0e0c_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_g0e0c_1"
}, O = {
  small: "has-small-padding",
  medium: "has-medium-padding",
  large: "has-large-padding"
}, w = {
  primary: "is-primary",
  secondary: "is-secondary",
  tertiary: "is-tertiary"
}, E = {
  none: "",
  top: "border-top",
  bottom: "border-bottom",
  topAndBottom: "border-top-and-bottom"
};
function R({
  children: n,
  className: _ = "",
  color: s,
  border: c = "none",
  isFullHeight: g,
  centerContent: d,
  isTopBottomPadding: m,
  padding: a = "medium",
  imageSrc: o,
  imagePosition: l,
  imageAlt: p,
  reverseBGColor: b,
  bgImage: t,
  ...h
}) {
  const y = r(
    e.section,
    _,
    s && e[w[s]],
    e[E[c]],
    g && e["is-full-height"],
    d && e["center-content"],
    o && e["image-flex"],
    l === "right" && e["image-reverse"],
    b && e["reverse-bg-color"]
  ), { isMobile: u } = v();
  return /* @__PURE__ */ f("section", { ...h, className: y, children: [
    o && /* @__PURE__ */ i("div", { className: e["image-container"], children: /* @__PURE__ */ i("img", { src: o, alt: p }) }),
    /* @__PURE__ */ i(
      "div",
      {
        className: r(
          e.content,
          m && e["is-top-bottom-padding"],
          a && e[O[a]],
          t && e["bg-image"]
        ),
        style: !u && t ? { backgroundImage: `url(${t})` } : {},
        children: n
      }
    )
  ] });
}
export {
  O as P,
  R as S,
  w as a,
  E as b
};
